export default "__VITE_ASSET__CoL1zcI6__"